import { Box, Typography } from '@mui/material'

interface PublicReportLayoutProps {
  title: string
  subtitle?: string
  actions?: React.ReactNode
  children: React.ReactNode
  isLoggedIn?: boolean
}

export function PublicReportLayout ({ title, subtitle, actions, children, isLoggedIn = false }: PublicReportLayoutProps): JSX.Element {
  return (
    <Box
      sx={{
        pt: 4,
        ml: isLoggedIn ? 0 : { md: '-120px' } // No negative margin when logged in (sidebar present)
      }}
    >
      {/* Only show title section when not logged in (public view) */}
      {!isLoggedIn && (
        <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 2, mb: 3 }}>
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="h3"
              component="h1"
              sx={{
                mb: subtitle != null ? 1 : 0,
                fontSize: { xs: '1.5rem', sm: '2rem', md: '3rem' }
              }}
            >
              {title}
            </Typography>
            {subtitle != null && (
              <Typography
                variant="h5"
                component="h2"
                sx={{
                  color: '#666',
                  fontWeight: 400,
                  fontSize: { xs: '1.1rem', sm: '1.25rem', md: '1.5rem' }
                }}
              >
                {subtitle}
              </Typography>
            )}
          </Box>
          {actions != null && (
            <Box sx={{ flexShrink: 0 }}>
              {actions}
            </Box>
          )}
        </Box>
      )}

      {/* Show actions separately when logged in */}
      {isLoggedIn && actions != null && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
          {actions}
        </Box>
      )}
      <Box>
        {children}
      </Box>
    </Box>
  )
}
